import { SET_UBER_TOKEN } from '../constants/ActionTypes';

export default function uberToken(state = '', action) {
    switch (action.type) {
        case SET_UBER_TOKEN:
            return action.uberToken;
        default:
            return state;
    }
}
